import { render, staticRenderFns } from "./RecentStoresMetric.vue?vue&type=template&id=2583d3dc&scoped=true"
import script from "./RecentStoresMetric.vue?vue&type=script&lang=js"
export * from "./RecentStoresMetric.vue?vue&type=script&lang=js"
import style0 from "./RecentStoresMetric.vue?vue&type=style&index=0&id=2583d3dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583d3dc",
  null
  
)

export default component.exports